module.exports = __webpack_public_path__ + "front/img/c14.88696063.png";